<template>
    <div class="privacy-policy-container">
      <h1 class="title">プライバシーポリシー</h1>
      <div class="policy-content">
        <p><strong>はじめに</strong></p>
        <p>本ウェブサイト（以下、「当サイト」といいます）は、利用者のプライバシーを尊重し、個人情報の保護に努めています。本プライバシーポリシーは、当サイトにおける個人情報の取扱いについて説明するものです。</p>
  
        <p><strong>1. 個人情報の取得</strong></p>
        <p>当サイトでは、以下の方法で利用者の個人情報を取得する場合があります。</p>
        <ul>
          <li>自動的に収集される情報（クッキー、アクセスログなど）</li>
        </ul>
  
        <p><strong>2. 個人情報の利用目的</strong></p>
        <p>当サイトでは、取得した個人情報を以下の目的で利用します。</p>
        <ul>
          <li>サービスの提供および運営</li>
          <li>お問い合わせ対応</li>
          <li>利用者の分析と改善</li>
          <li>法令に基づく場合</li>
        </ul>
  
        <p><strong>3. 個人情報の第三者提供</strong></p>
        <p>当サイトでは、利用者の個人情報を第三者に提供することはありません。ただし、以下の場合を除きます。</p>
        <ul>
          <li>利用者の同意がある場合</li>
          <li>法令に基づく場合</li>
          <li>利用目的の達成に必要な範囲内で業務委託先に提供する場合</li>
        </ul>
  
        <p><strong>4. 個人情報の管理</strong></p>
        <p>当サイトでは、利用者の個人情報を適切に管理し、不正アクセス、紛失、破壊、改ざんおよび漏洩から保護するために必要な措置を講じます。</p>
  
        <p><strong>5. クッキーについて</strong></p>
        <p>当サイトでは、利用者の利便性向上やサイトの利用状況の把握のためにクッキーを使用することがあります。クッキーの使用に関しては、ブラウザの設定で拒否することができますが、その場合、当サイトの一部の機能が利用できない場合があります。</p>
  
        <p><strong>6. アクセス解析ツールについて</strong></p>
        <p>当サイトでは、Googleアナリティクスなどのアクセス解析ツールを使用して、利用者のアクセス情報を収集しています。これらのツールは、クッキーを使用して利用者のトラフィックデータを収集しますが、個人を特定する情報は含まれていません。</p>
  
        <p><strong>7. プライバシーポリシーの変更</strong></p>
        <p>本プライバシーポリシーは、必要に応じて変更されることがあります。変更後のプライバシーポリシーは、当サイトに掲載された時点で効力を生じるものとします。</p>
      </div>
    </div>
  </template>
  
  <script>
  export default {
    name: "PrivacyPolicy",
  };
  </script>
  
  <style scoped>
  .privacy-policy-container {
    padding: 20px;
    max-width: 800px;
    margin: 0 auto;
  }
  
  .title {
    font-size: 24px;
    font-weight: bold;
    margin-bottom: 20px;
  }
  
  .policy-content {
    font-size: 14px;
    line-height: 1.6;
  }
  
  .policy-content ul {
    list-style-type: disc;
    padding-left: 20px;
  }
  
  .policy-content p, .policy-content ul {
    margin-bottom: 16px;
  }
  </style>